export default __webpack_public_path__ + "static/media/StaticHeaader.fc37e5d4.png";